/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */ // base values
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var EN_LANGUAGE = "en";
var DE_LANGUAGE = "de";
var NL_LANGUAGE = "nl";
var FR_LANGUAGE = "fr";
var ES_LANGUAGE = "es";
var US_REGION = "US";
var DE_REGION = "DE";
var NL_REGION = "NL";
var FR_REGION = "FR";
var GB_REGION = "GB";
var ALL_LANGUAGES = [
    EN_LANGUAGE,
    DE_LANGUAGE,
    NL_LANGUAGE,
    FR_LANGUAGE,
    ES_LANGUAGE
];
var EN_US_LOCALE = "".concat(EN_LANGUAGE, "-").concat(US_REGION);
var ES_US_LOCALE = "".concat(ES_LANGUAGE, "-").concat(US_REGION);
var DE_DE_LOCALE = "".concat(DE_LANGUAGE, "-").concat(DE_REGION);
var EN_DE_LOCALE = "".concat(EN_LANGUAGE, "-").concat(DE_REGION);
var NL_NL_LOCALE = "".concat(NL_LANGUAGE, "-").concat(NL_REGION);
var EN_NL_LOCALE = "".concat(EN_LANGUAGE, "-").concat(NL_REGION);
var FR_FR_LOCALE = "".concat(FR_LANGUAGE, "-").concat(FR_REGION);
var EN_FR_LOCALE = "".concat(EN_LANGUAGE, "-").concat(FR_REGION);
var EN_GB_LOCALE = "".concat(EN_LANGUAGE, "-").concat(GB_REGION);
var ALL_REGIONS = [
    US_REGION,
    DE_REGION,
    NL_REGION,
    FR_REGION,
    GB_REGION
];
var EU_REGIONS = [
    DE_REGION,
    NL_REGION,
    FR_REGION,
    GB_REGION
];
var ACTIVE_REGIONS = [
    US_REGION,
    DE_REGION,
    NL_REGION,
    FR_REGION,
    GB_REGION
];
var ALL_LOCALES = [
    EN_US_LOCALE,
    DE_DE_LOCALE,
    EN_DE_LOCALE,
    NL_NL_LOCALE,
    EN_NL_LOCALE,
    FR_FR_LOCALE,
    EN_FR_LOCALE,
    EN_GB_LOCALE,
    ES_US_LOCALE
];
var ACTIVE_LOCALES = [
    EN_US_LOCALE,
    DE_DE_LOCALE,
    EN_DE_LOCALE,
    NL_NL_LOCALE,
    EN_NL_LOCALE,
    FR_FR_LOCALE,
    EN_FR_LOCALE,
    EN_GB_LOCALE
];
var DEFAULT_LOCALE = EN_US_LOCALE;
// extra config
var DEFAULT_REGION = US_REGION;
var DEFAULT_LANGUAGE = EN_LANGUAGE;
var _obj;
var LOCALES_PER_REGION = (_obj = {}, _define_property(_obj, US_REGION, [
    EN_US_LOCALE,
    ES_US_LOCALE
]), _define_property(_obj, DE_REGION, [
    DE_DE_LOCALE,
    EN_DE_LOCALE
]), _define_property(_obj, NL_REGION, [
    NL_NL_LOCALE,
    EN_NL_LOCALE
]), _define_property(_obj, FR_REGION, [
    FR_FR_LOCALE,
    EN_FR_LOCALE
]), _define_property(_obj, GB_REGION, [
    EN_GB_LOCALE
]), _obj);
var _obj1;
var DEFAULT_LANGUAGE_BY_REGION = (_obj1 = {}, _define_property(_obj1, US_REGION, EN_LANGUAGE), _define_property(_obj1, DE_REGION, DE_LANGUAGE), _define_property(_obj1, NL_REGION, NL_LANGUAGE), _define_property(_obj1, FR_REGION, FR_LANGUAGE), _define_property(_obj1, GB_REGION, EN_LANGUAGE), _obj1);
var _obj2;
var LANGUAGE_DISPLAY_NAMES = (_obj2 = {}, _define_property(_obj2, EN_LANGUAGE, "English"), _define_property(_obj2, DE_LANGUAGE, "Deutsch"), _define_property(_obj2, NL_LANGUAGE, "Dutch"), _define_property(_obj2, FR_LANGUAGE, "Fran\xe7ais"), _define_property(_obj2, ES_LANGUAGE, "Spanish"), _obj2);
var _obj3;
var REGION_ALIASES = (_obj3 = {}, _define_property(_obj3, US_REGION, ""), _define_property(_obj3, DE_REGION, DE_REGION.toLowerCase()), _define_property(_obj3, NL_REGION, NL_REGION.toLowerCase()), _define_property(_obj3, FR_REGION, FR_REGION.toLowerCase()), _define_property(_obj3, GB_REGION, "uk"), _obj3);
var ALIASES_FOR_REGIONS = Object.entries(REGION_ALIASES).reduce(function(acc, param) {
    var _param = _sliced_to_array(param, 2), region = _param[0], alias = _param[1];
    return _object_spread_props(_object_spread({}, acc), _define_property({}, alias, region));
}, {});

export { ACTIVE_LOCALES, ACTIVE_REGIONS, ALIASES_FOR_REGIONS, ALL_LANGUAGES, ALL_LOCALES, ALL_REGIONS, DEFAULT_LANGUAGE, DEFAULT_LANGUAGE_BY_REGION, DEFAULT_LOCALE, DEFAULT_REGION, DE_DE_LOCALE, DE_LANGUAGE, DE_REGION, EN_DE_LOCALE, EN_FR_LOCALE, EN_GB_LOCALE, EN_LANGUAGE, EN_NL_LOCALE, EN_US_LOCALE, ES_LANGUAGE, ES_US_LOCALE, EU_REGIONS, FR_FR_LOCALE, FR_LANGUAGE, FR_REGION, GB_REGION, LANGUAGE_DISPLAY_NAMES, LOCALES_PER_REGION, NL_LANGUAGE, NL_NL_LOCALE, NL_REGION, REGION_ALIASES, US_REGION };
